// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAlT0Oix7ACaxXxNGgsXTmNXQ5Cir1luPM",
  authDomain: "lines-group-uk.firebaseapp.com",
  projectId: "lines-group-uk",
  storageBucket: "lines-group-uk.firebasestorage.app",
  messagingSenderId: "605059898694",
  appId: "1:605059898694:web:8ce11d069ddfeebae8d947",
  measurementId: "G-R0SR1XD7B3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);